import React from 'react'

function banner() {
  return (
    <div>
        <div className='bg-primary sect-spacer'>
            <div className="uk-container">
                <div className="">
                    <div>
                        <div className="">
                            <h1 className="text-primary uk-text-center">
                            About Us
                            </h1>
                            <p className='uk-text-left text-secondary uk-text-center'>
                                Established in 2017, STRATOS AIRMAIL set out with a vision of delivering zero failure service across India and beyond, offering excellent services in key cities such as Tiruppur, Coimbatore, Delhi, Noida, Faridabad, Gurugram, Erode, Karur, Salem, Chennai, Surat, Thane, Vapi, Mumbai, Navi Mumbai and more metro cities. Our mission was to revolutionize the logistics industry through innovation and an unwavering commitment to customer satisfaction. Utilizing our proprietary logistics operating system, we ensure the highest level of security and efficiency, providing our customers with peace of mind knowing their shipments are always safe and secure.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default banner